<script lang="ts">
  import Navbar from '../components/Navbar.svelte';
  import { push } from 'svelte-spa-router';

  let formData = {
    project: '',
    repository: '',
    branch: 'main',
    environment: 'production',
    buildCommand: 'npm run build',
    outputDirectory: 'dist',
    envVars: ''
  };

  let loading = false;
  let error = '';

  async function handleSubmit() {
    loading = true;
    error = '';

    try {
      // TODO: Replace with actual API call
      await new Promise(resolve => setTimeout(resolve, 1500));

      // Simulate success
      console.log('Deployment created:', formData);
      push('/deployments');
    } catch (e) {
      error = 'Failed to create deployment. Please try again.';
      console.error('Deployment error:', e);
    } finally {
      loading = false;
    }
  }

  function handleCancel() {
    push('/deployments');
  }
</script>

<Navbar />

<div class="min-h-screen bg-gray-50 dark:bg-gray-900">
  <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <div class="mb-8">
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">New Deployment</h1>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">Deploy your application to production or staging environment</p>
    </div>

    {#if error}
      <div class="mb-6 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-700 dark:text-red-400 px-4 py-3 rounded">
        {error}
      </div>
    {/if}

    <form on:submit|preventDefault={handleSubmit} class="bg-white dark:bg-gray-800 shadow-sm rounded-lg border border-gray-200 dark:border-gray-700">
      <div class="p-6 space-y-6">
        <!-- Project Name -->
        <div>
          <label for="project" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Project Name
          </label>
          <input
            type="text"
            id="project"
            bind:value={formData.project}
            required
            placeholder="my-awesome-project"
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100"
          />
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">A unique name for your project</p>
        </div>

        <!-- Repository -->
        <div>
          <label for="repository" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Repository
          </label>
          <input
            type="text"
            id="repository"
            bind:value={formData.repository}
            required
            placeholder="username/repository"
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100"
          />
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Select a repository from your account</p>
        </div>

        <!-- Branch -->
        <div>
          <label for="branch" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Branch
          </label>
          <input
            type="text"
            id="branch"
            bind:value={formData.branch}
            required
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100"
          />
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">The branch to deploy from</p>
        </div>

        <!-- Environment -->
        <div>
          <label for="environment" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Environment
          </label>
          <select
            id="environment"
            bind:value={formData.environment}
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100"
          >
            <option value="production">Production</option>
            <option value="staging">Staging</option>
            <option value="development">Development</option>
          </select>
        </div>

        <!-- Build Command -->
        <div>
          <label for="buildCommand" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Build Command
          </label>
          <input
            type="text"
            id="buildCommand"
            bind:value={formData.buildCommand}
            required
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100 font-mono text-sm"
          />
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Command to build your project (e.g., npm run build)</p>
        </div>

        <!-- Output Directory -->
        <div>
          <label for="outputDirectory" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Output Directory
          </label>
          <input
            type="text"
            id="outputDirectory"
            bind:value={formData.outputDirectory}
            required
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100 font-mono text-sm"
          />
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Directory where build artifacts are output</p>
        </div>

        <!-- Environment Variables -->
        <div>
          <label for="envVars" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Environment Variables (Optional)
          </label>
          <textarea
            id="envVars"
            bind:value={formData.envVars}
            rows="4"
            placeholder="KEY=value&#10;ANOTHER_KEY=another_value"
            class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-gray-100 font-mono text-sm"
          ></textarea>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">One variable per line in KEY=value format</p>
        </div>
      </div>

      <!-- Actions -->
      <div class="px-6 py-4 bg-gray-50 dark:bg-gray-700/50 border-t border-gray-200 dark:border-gray-700 flex items-center justify-end space-x-3">
        <button
          type="button"
          on:click={handleCancel}
          disabled={loading}
          class="px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          class="px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? 'Creating...' : 'Create Deployment'}
        </button>
      </div>
    </form>
  </div>
</div>
